import { render, staticRenderFns } from "./Alibaba-received-info.vue?vue&type=template&id=a294c1f8&scoped=true&"
import script from "./Alibaba-received-info.vue?vue&type=script&lang=js&"
export * from "./Alibaba-received-info.vue?vue&type=script&lang=js&"
import style0 from "./Alibaba-received-info.vue?vue&type=style&index=0&id=a294c1f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a294c1f8",
  null
  
)

export default component.exports